
import React from 'react'
import { some, get } from 'lodash'
const withReloadable = (WrappedComponent, keys) => {
  class Reloadable extends React.Component {
    constructor (props) {
      super(props)
      this.state = {
        reload: false
      }
    }

    componentWillReceiveProps (nextProps) {
      const currentProps = this.props
      const shouldReload = some(keys, (key) => (get(currentProps, key) !== get(nextProps, key)))
      if (shouldReload) {
        // console.info(`[withReloadable]: reloading Component due`, keys)
        this.setState({ reload: true }, () => this.setState({ reload: false }))
      }
    }

    render () {
      return this.state.reload ? null : <WrappedComponent {...this.props} />
    }
  }

  return Reloadable
}

export default withReloadable
